var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { fittingTypes } from '../imageService/imageTransform';
const SHAPE_TYPE = 'shape';
const TINT_TYPE = 'tint';
// resetting CSS variables on SVG change, based on the new SVG type
function resetSvgStylesForType({ style, newSvgType, }) {
    const isShapeType = newSvgType === SHAPE_TYPE;
    const isTintType = newSvgType === TINT_TYPE;
    const notShapeOrTint = !isShapeType && !isTintType;
    const shapeStrokeKeys = ['stroke', 'alpha-stroke', 'stroke-width'];
    const keysToDelete = [
        'svg-color-1',
        'svg-color-2',
        'svg-color-3',
        'svg-color-4',
        'svg-color-5',
        'svg-color-6',
        'svg-color-7',
        'svg-color-8',
    ];
    if (!isShapeType) {
        keysToDelete.push(...shapeStrokeKeys);
    }
    if (notShapeOrTint) {
        keysToDelete.push('fill');
    }
    const newStyle = Object.fromEntries(Object.entries(style).filter(([key]) => !keysToDelete.includes(key)));
    // if converted to shape or tint AND had single color, keep it
    if (!notShapeOrTint && style['svg-color-1'] && !style['svg-color-2']) {
        newStyle.fill = style['svg-color-1'];
    }
    return newStyle;
}
export function replaceSvgImage(props) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a;
        const { fetchSvg, waitForChangesApplied: waitForChangesAppliedProp, getSvgInfoFromCache, updateData, compStyle, updateStyle, addToHistory, getSvgOriginalAspectRatio, resetCompLayoutToAspectRatio, compRef, compData, newSvgId, callback, } = props;
        const waitForChangesApplied = (payload) => {
            return new Promise((resolve) => {
                waitForChangesAppliedProp(() => {
                    resolve(payload);
                });
            });
        };
        const { svgId, alt } = compData;
        yield fetchSvg(newSvgId, () => { });
        yield waitForChangesApplied();
        const newSvgType = (_a = getSvgInfoFromCache(newSvgId)) === null || _a === void 0 ? void 0 : _a.svgType;
        const altData = svgId !== newSvgId ? '' : alt;
        const newDisplayMode = ['color', 'tint', 'ugc'].includes(newSvgType)
            ? 'fit'
            : compData.displayMode;
        updateData(compRef, Object.assign(Object.assign({}, compData), { svgId: newSvgId, displayMode: newDisplayMode, alt: altData }), true);
        updateStyle(compRef, Object.assign(Object.assign({}, compStyle), { style: Object.assign(Object.assign({}, compStyle.style), { properties: resetSvgStylesForType({
                    style: compStyle.style.properties,
                    newSvgType,
                }) }) }));
        // After layout, relayout
        yield waitForChangesApplied();
        // Reset aspect ratio by displayMode
        if (getSvgOriginalAspectRatio &&
            resetCompLayoutToAspectRatio &&
            newDisplayMode === fittingTypes.SCALE_TO_FIT) {
            const newShapeAspectRatio = getSvgOriginalAspectRatio(compRef);
            resetCompLayoutToAspectRatio(compRef, newShapeAspectRatio, true);
        }
        addToHistory('Change Svg Image');
        callback === null || callback === void 0 ? void 0 : callback(newSvgId);
        return newSvgId;
    });
}
